import styled from 'styled-components';

export const AccountsTable = styled.div`
  font-size: 14px;
  background-color: inherit;
  line-height: 50px;
  overflow: auto;
`;
